module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#next-story",
      toString: function () {
        return this.url;
      }
    }